import React from "react";
import AppHeader from "./components/app-header/app-header";
import { MainPage } from "./components/main-page/main-page";

import { ApolloProvider } from "@apollo/client";
import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";

import { apolloClient } from "./apollo-client";
import { reactPlugin } from "./app-insights";
import AppContent from "./components/HOC/app-content/app-content.component";
import StoreProvider from "./components/HOC/store-provider/store-provider.component";
import AuthProvider from "./auth/auth-provider";

function ApolloConnection() {
  return (
    <ApolloProvider client={apolloClient}>
      <AppInsightsContext.Provider value={reactPlugin}>
        <StoreProvider>
          <AppContent>
            <MainPage />
          </AppContent>
        </StoreProvider>
      </AppInsightsContext.Provider>
    </ApolloProvider>
  );
}

function App() {
  return (
    <div>
      <AuthProvider>
        <AppHeader></AppHeader>
        <ApolloConnection />
      </AuthProvider>
    </div>
  );
}

export default App;
